import { parse, isValid } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

/**
 * Attempt to parse a date string into a Date object.
 *
 * @param input - the input string to parse
 * @param timeZone - the assumed timezone of the input string.
 */
export function parseDateInput(
  input: string,
  timeZone: string,
): Date | undefined {
  const trimmed = input.trim();

  if (!trimmed) {
    return undefined;
  }

  for (const dateFormat of formats) {
    // the reference date won't end up being used with the current set of formats.
    const parsed = parse(trimmed, dateFormat, referenceDate);

    if (!isValid(parsed)) {
      continue;
    }

    return zonedTimeToUtc(parsed, timeZone);
  }

  return undefined;
}

const referenceDate = new Date(2000, 0, 1);

const formats = [
  "d/M/yyyy",
  "dd/MM/yyyy",
  "d-M-yyyy",
  "dd-MM-yyyy",
  "d MMM yyyy",
  "d MMMM yyyy",

  "yyyy-MM-dd",
  "yyyy-MM-dd HH:mm:ss",
  "yyyy-MM-dd HH:mm:ss.SSS",
  "yyyy-MM-dd HH:mm",

  "d/M/yyyy H:mm",
  "dd/MM/yyyy HH:mm",
  "d-M-yyyy H:mm",
  "dd-MM-yyyy HH:mm",
  "d MMM yyyy H:mm",
  "d MMMM yyyy H:mm",

  "d/M/yyyy h:mm a",
  "dd/MM/yyyy h:mm a",
  "d-M-yyyy h:mm a",
  "dd-MM-yyyy h:mm a",
  "d MMM yyyy h:mm a",
  "d MMMM yyyy h:mm a",

  "d/M/yyyy h:mm:ss a",
  "dd/MM/yyyy h:mm:ss a",
  "d-M-yyyy h:mm:ss a",
  "dd-MM-yyyy h:mm:ss a",
  "d MMM yyyy h:mm:ss a",
  "d MMMM yyyy h:mm:ss a",

  "d/M/yyyy h:mm:ss.S a",
  "dd/MM/yyyy h:mm:ss.S a",
  "d-M-yyyy h:mm:ss.S a",
  "dd-MM-yyyy h:mm:ss.S a",
  "d MMM yyyy h:mm:ss.S a",
  "d MMMM yyyy h:mm:ss.S a",

  "d/M/yyyy h:mm:ss.SS a",
  "dd/MM/yyyy h:mm:ss.SS a",
  "d-M-yyyy h:mm:ss.SS a",
  "dd-MM-yyyy h:mm:ss.SS a",
  "d MMM yyyy h:mm:ss.SS a",
  "d MMMM yyyy h:mm:ss.SS a",

  "d/M/yyyy h:mm:ss.SSS a",
  "dd/MM/yyyy h:mm:ss.SSS a",
  "d-M-yyyy h:mm:ss.SSS a",
  "dd-MM-yyyy h:mm:ss.SSS a",
  "d MMM yyyy h:mm:ss.SSS a",
  "d MMMM yyyy h:mm:ss.SSS a",
];
